<section class="section-wrapper seventh-container-lg background-image">
  <div class="d-flex align-items-center flex-direction-column">
    <div class="container seventh-container flex-direction-column align-items-center">
      <div class="seventh-section-title" [ngClass]="{'seventh-section-title-ru': currentLang === Language.RU}">
        {{ 'home-page-content.connect_instantly' | translate }}
      </div>
      <div class="seventh-section-subtitle" [ngClass]="{'seventh-section-subtitle-ru': currentLang === Language.RU}">
        {{ 'home-page-content.connect_instantly_text' | translate }}
      </div>
      <div class="seventh-section-buttons">
        <button class="filled-button tall-button seventh-section-first-button"
                (click)="createCard()">{{ 'home-page-content.create_individual_card' | translate }}
        </button>
        <button class="outlined-button tall-button"
                (click)="createCard()">{{ 'home-page-content.create_team_card' | translate }}
        </button>
      </div>
    </div>
  </div>
</section>

<section class="section-wrapper-mb seventh-container-mb mt-70px">
  <div class="d-flex align-items-center flex-direction-column">
    <div class="seventh-section-background-wrapper">
      <img src="assets/homepage/connect-digital-business-card/background-mb.png" alt="background"
           class="seventh-section-background">
    </div>
    <div class="seventh-container flex-direction-column align-items-center">
      <div class="seventh-section-title">
        {{ 'home-page-content.connect_instantly' | translate }}
      </div>
      <div class="seventh-section-subtitle">
        {{ 'home-page-content.connect_instantly_text' | translate }}
      </div>
      <button class="filled-button tall-button mobile-button mt-4"
              (click)="createCard()">{{ 'home-page-content.create_individual_card' | translate }}
      </button>
      <button class="outlined-button tall-button mobile-button mt-3"
              (click)="createCard()">{{ 'home-page-content.create_team_card' | translate }}
      </button>
    </div>
  </div>
</section>
